import { RenderElementProps, RenderLeafProps } from 'slate-react';
import { CustomEditor } from 'slate/types/slate';
import DiffedElement from './components/DiffedElement';
import DiffedLeaf from './components/DiffedLeaf';

interface SideBySideOptions {
  side?: 'left' | 'right';
  readOnly?: boolean;
}

const withSideBySide =
  (options: SideBySideOptions = {}) =>
  (editor: CustomEditor) => {
    const { renderElement, renderLeaf } = editor;
    const { side, readOnly } = options;
    editor.renderElement = (props: RenderElementProps) => {
      return <DiffedElement {...props} readOnly={readOnly} side={side} renderElement={renderElement} />;
    };
    editor.renderLeaf = (props: RenderLeafProps) => {
      return <DiffedLeaf {...props} side={side} renderLeaf={renderLeaf} />;
    };
    return editor;
  };

export default withSideBySide;
